import { noop, get } from 'lodash';
import { connect } from 'react-redux';
import { branch, compose, lifecycle, renderNothing, withProps, withState } from 'recompose';

import { getTableDataFromMembershipAndShops } from './utils';
import { getActiveBrandShops } from '../../../auth/selectors';
import withAssignmentHandlers from './withAssignmentHandlers';
import { fetchBrandMembership, fetchShopMembership } from '../actions';
import withOwnerTypeAndId from '../../../common/hoc/withOwnerTypeAndId';
import { bindActionsForRoles } from '../../../common/helpers/actions';

const MembershipShopsContainer = compose(
  withOwnerTypeAndId,
  connect(
    state => ({
      shops: getActiveBrandShops(state),
    }),
    dispatch => ({
      fetchMembership: bindActionsForRoles(dispatch, fetchShopMembership, noop, fetchBrandMembership),
    }),
  ),
  withState('membership', 'setMembership', props => props.membership),
  lifecycle({
    componentWillMount() {
      this.props.fetchMembership[this.props.ownerType](this.props.ownerId, this.props.routeParams.id)
        .then((membership) => {
          this.props.setMembership(membership);
        });
    },
  }),
  branch(
    props => !props.membership,
    renderNothing,
  ),
  withProps((props) => {
    const shopAssignees = props.membership.assignees.filter(a => a.assigneeType === 'shop');
    const tableData = getTableDataFromMembershipAndShops(props.membership, props.shops);

    return {
      items: tableData,
      totalLocations: props.shops.length,
      assignedLocations: shopAssignees.length,
      activeMembers: get(props.membership, 'counts.active', 0),
      totalMembers: get(props.membership, 'counts.total', 0),
      membershipOwnerType: shopAssignees.some(a => a.isCreator) ? 'shop' : 'brand',
    };
  }),
  withAssignmentHandlers,
);

export default MembershipShopsContainer;
